var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProductImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    id: "image",
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .vi-primary {\n        fill: #FF6E6E;\n      }\n\n      .vi-primary, .vi-accent {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 0;\n      }\n\n      .vi-accent {\n        fill: #0C0058;\n        fill-rule: evenodd;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "vi-primary",
    height: 26,
    width: 36,
    x: 6,
    y: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "vi-accent",
    d: "M6,37L19,24l5,5L35,18l7,7V37H6ZM24.5,17A2.5,2.5,0,1,1,22,19.5,2.5,2.5,0,0,1,24.5,17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProductImg);
export default __webpack_public_path__ + "static/media/defaultProductImg.ca3b4647270c614be86782e54306c52e.svg";
export { ForwardRef as ReactComponent };